// extracted by mini-css-extract-plugin
module.exports = {"responsePage":"styles_responsePage__2ZEpm","logoWrapper":"styles_logoWrapper__1Xqso","title":"styles_title__vyWA9","description":"styles_description__xI1AK"};